(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ze-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
    class ZeShoppableVideos extends HTMLElement {
      constructor() {
        super();

        if (!document.querySelector('#swiper-stylesheet')) {
          const stylesheet = document.createElement('link');
          stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css');
          stylesheet.setAttribute('rel', 'stylesheet');
          stylesheet.setAttribute('id', 'swiper-stylesheet');
          stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=');
          stylesheet.setAttribute('crossorigin', 'anonymous');
          document.head.appendChild(stylesheet);
        }

        if (!document.querySelector('#swiper-script')) {
          const script = document.createElement('script');
          script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js');
          script.setAttribute('id', 'swiper-script');
          script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=');
          script.setAttribute('crossorigin', 'anonymous');
          script.defer = true;
          document.head.appendChild(script);
        }

        
        const initSwiper = () => {
          if (typeof window.Swiper === 'undefined') {
            requestAnimationFrame(initSwiper);
            return;
          }

          const slider = new window.Swiper(this.querySelector('.swiper'), this.sliderOptions());

          slider.on('slideChange', () => {
            this.querySelector('.swiper').classList.add('swiper-is-changing');
            this.onSlideChange();
          });

          slider.on('slideChangeTransitionEnd', () => {
            this.querySelector('.swiper').classList.remove('swiper-is-changing');
          });
        };

        initSwiper();

        this.querySelectorAll('.ze-shoppable-videos-btn-play').forEach((btn) => {
          btn.addEventListener('click', () => {
            const video = btn.closest('.ze-shoppable-videos-video-wrapper').querySelector('video');
            this.onVideoPlay(video);
          });
        });

        this.querySelectorAll('video').forEach((video) => {
          video.addEventListener('click', () => {
            this.onVideoPlay(video);
          });
        });

        const lazyVideosObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.play();
            }
          });
        }, { rootMargin: '0px 0px 300px 0px' });

        this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
          lazyVideosObserver.observe(el);
        });
      }

      sliderOptions() {
        const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1;

        return {
          rewind: true,
          speed: Number(this.dataset.sliderSpeed),
          breakpoints: {
            0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
            576: { slidesPerView: Number(this.dataset.breakpointSm) },
            768: { slidesPerView: Number(this.dataset.breakpointMd) },
            992: { slidesPerView: Number(this.dataset.breakpointLg) },
            1200: { slidesPerView: Number(this.dataset.breakpointXl) },
            1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
          },
          navigation: {
            enabled: this.dataset.sliderNav === 'true',
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev')
          },
          pagination: {
            enabled: this.dataset.sliderPagination === 'true',
            type: this.dataset.sliderPaginationType,
            el: this.querySelector('.swiper-pagination'),
            dynamicBullets: true,
            dynamicMainBullets: 2,
            renderFraction: function(currentClass, totalClass) {
              return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
            }
          },
          scrollbar: {
            enabled: this.dataset.sliderScrollbar === 'true',
            el: this.querySelector('.swiper-scrollbar'),
            draggable: true
          },
          autoplay: this.dataset.sliderAutoplay !== '0'
            ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
            : undefined,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true
          }
        };
      }

      onSlideChange() {
        this.querySelectorAll('.ze-shoppable-videos-card').forEach((elem) => {
          elem.setAttribute('data-is-playing', 'false');
          elem.querySelector('video')?.pause();
        });
      }

      onVideoPlay(video) {
        const card = video.closest('.ze-shoppable-videos-card');

        this.querySelectorAll('.ze-shoppable-videos-card').forEach((elem) => {
          if (elem.dataset.index !== card.dataset.index) {
            elem.setAttribute('data-is-playing', 'false');
            elem.querySelector('video')?.pause();
          }
        });

        if (card.dataset.isPlaying === 'true') {
          card.setAttribute('data-is-playing', 'false');
          video.pause();
        } else {
          card.setAttribute('data-is-playing', 'true');
          video.muted = false;
          video.play();
        }
      }
    }

    customElements.define('ze-shoppable-videos', ZeShoppableVideos);
  
  } catch(e) { console.error(e); }
})();
})();
